import React from 'react';

import { useTranslation } from 'react-i18next';

import AdminService from '../../../../../services/AdminService';
import TableView from '../../TableView';

export default function CompanyTags({ setItemCount }) {
  const { t } = useTranslation();

  const columns = [
    {
      name: t('dashboardComponents.Console.CompanyManagement.tags.tagName'),
      field: 'name',
      sortable: true,
    },
    {
      name: t('common.sortOrder'),
      field: 'sortOrder',
      sortable: true,
    },
    {
      name: t('common.notes'),
      field: 'note',
      sortable: false,
    },
    {
      name: t('common.createdOn'),
      field: 'createdAt',
      sortable: true,
      type: 'date',
    },
  ];

  return (
    <TableView
      setItemCount={setItemCount}
      dataName="Tag"
      getDataHandler={AdminService.getCompanyTags}
      deleteDataHandler={AdminService.deleteCompanyTag}
      createDataHandler={AdminService.createCompanyTag}
      updateDataHandler={AdminService.updateCompanyTag}
      viewLeftColumnFields={[
        {
          label: t(
            'dashboardComponents.Console.CompanyManagement.tags.tagName'
          ),
          field: 'name',
        },
      ]}
      viewRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
        },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
        },
      ]}
      formLeftColumnFields={[
        {
          label: t(
            'dashboardComponents.Console.CompanyManagement.tags.tagName'
          ),
          field: 'name',
          validation: ['string', 'required'],
          placeholder: t(
            'dashboardComponents.Console.CompanyManagement.tags.tagNamePlaceholder'
          ),
        },
      ]}
      formRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
          validation: ['string', 'required', 'numbers'],
          placeholder: t(
            'dashboardComponents.Console.CompanyManagement.tags.sortOrderPlaceholder'
          ),
          maxLength: 5,
        },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
          validation: ['string'],
          placeholder: t(
            'dashboardComponents.Console.CompanyManagement.tags.notesPlaceholder'
          ),
        },
      ]}
      columns={columns}
    />
  );
}
